import CookieUtil from '@/assets/js/CookieUtil'
import { RouteHook } from '@/assets/js/HttpUtil'
import { cookieTypes, StoreTypes } from '@/assets/js/Types'
import Vue from 'vue'
import store from "../store/index"
import VueRouter, { RouteConfig } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import MainView from '../views/MainView.vue'
import AdminView from '../views/AdminView.vue'
import MapView from '../views/Admin/NewMapView.vue'
import GatewayMapView from '../views/Admin/GatewayMapView.vue'
import DataView from '../views/Admin/DataView.vue'
import DeviceView from '../views/Admin/DeviceView.vue'
import SetView from '../views/Admin/SetView.vue'
import RouterView from '../views/Admin/RouterView.vue'
import CtrView from '../views/Admin/CtrView.vue'
import LoopView from '../views/Admin/LoopNewView.vue'
import SenceView from '../views/Admin/SenceView.vue'
import AlarmView from '../views/Admin/AlarmsView.vue'
import HistoryView from '../views/Admin/HistoryViewNew.vue'
import GatewayDetail from "../views/Admin/GatewayDetail.vue"
import PlatPolicyView from "../views/Admin/PlatPolicyView.vue"
import JingGView from "../views/Admin/JGView.vue"
import JGDetail from "../views/Admin/JGDetail.vue"
import DataCnViewVue from '@/views/Admin/DataCnView.vue'
import LightDetail from "@/views/Admin/LightDetail.vue"
import LightSenceView from "@/views/Admin/LightSenceView.vue"
import OrderViewVue from '@/views/Admin/OrderView.vue'
import OrderDetail from '@/views/Admin/Order/OrderDetail.vue'
import InspectionVue from '@/views/Inspection.vue'
import KPIDetailVue from '@/views/KPIDetail.vue'
import HomeView from '@/views/Admin/Home.vue'
import HomeMain from '@/views/Admin/Home/HomeMain.vue'
import OView from "@/views/Admin/Home/OView.vue"
import CamaraVue from '@/views/Admin/Home/Cara/Camara.vue'
import CaraOview from '@/views/Admin/Home/Cara/OView.vue'
import CamraDevice from '@/views/Admin/Home/Cara/Device.vue'
import HomeAlarm from '@/views/Admin/Home/Alarm.vue'
import VideoDetailVue from '@/views/Admin/Home/Cara/VideoDetail.vue'
import AlarmLinkVue from '@/views/Admin/Home/AlarmLink.vue'
import AISubVue from '@/views/Admin/Home/Cara/AISub.vue'
import NormalDeviceVue from '@/views/Admin/Home/NormalDevice.vue'
import BroadDevice from "@/views/Admin/Home/Broad/Device.vue"
import LinkTextVue from '@/views/Admin/Home/Broad/LinkText.vue'
import DustCarDeviceVue from '@/views/Admin/Home/DustCarDevice.vue'
import SensorDeviceCompoentVue from '@/views/Admin/LightSence/SensorDeviceCompoent.vue'
import SenceCompoentVue from '@/views/Admin/LightSence/SenceCompoent.vue'
import OrderAminViewVue from '@/views/Admin/Order/OrderAminView.vue'
import OrderTypeVue from '@/views/Admin/Order/OrderType.vue'
import CheckViewVue from '@/views/Admin/Order/CheckView.vue'
import WorkOrderViewVue from '@/views/Admin/Order/WorkOrderView.vue'
import OrderOViewVue from '@/views/Admin/Order/OrderOView.vue'
import PhoneAlarmVue from '@/views/Admin/SetCompoents/PhoneAlarm.vue'
import ProjectAdminComVue from '@/views/Admin/SetCompoents/ProjectAdminCom.vue'
import ProjectInfoComVue from '@/views/Admin/SetCompoents/ProjectInfoCom.vue'
import ProjectLogVue from '@/views/Admin/SetCompoents/ProjectLog.vue'
import ProjectPowerComVue from '@/views/Admin/SetCompoents/ProjectPowerCom.vue'
import ProjectRoleComVue from '@/views/Admin/SetCompoents/ProjectRoleCom.vue'
import ProjectUserComVue from '@/views/Admin/SetCompoents/ProjectUserCom.vue'
import EnvCarDeviceVue from '@/views/Admin/Home//EnvCAR/EnvCarDevice.vue'
import EnvCarLogVue from '@/views/Admin/Home/EnvCAR/EnvCarLog.vue'
import EnvCarPotinerVue from '@/views/Admin/Home/EnvCAR/EnvCarPotiner.vue'
import NormalDeviceCoverVue from '@/views/Admin/Home/NormalDeviceCover.vue'
import NormalDeviceDetailVue from '@/views/Admin/Home/NormalDeviceDetail.vue'
import EnvCarDeviceDetailVue from '@/views/Admin/Home/EnvCAR/DeviceDetail.vue'
import CamaraCeviceVue from '@/views/Admin/Home/Cara/CamaraCevice.vue'
// import ClightDevice from '@/views/Admin/Home/ClightDevice.vue'
import ClightDevice from '@/views/Admin/DeviceCompoents/DeviceAdminCom.vue'
import CnComVue from '@/views/Admin/CtrComponents/CnCom.vue'
import cnPolicyComVue from '@/views/Admin/SenceComponents/cnPolicyCom.vue'
import tunnelPolicyComVue from '@/views/Admin/SenceComponents/tunnelPolicyCom.vue'

import TaskCom from '@/views/Admin/SenceComponents/TaskCom.vue'
import TunnelOViewVue from '@/views/Admin/Home/TunnelOView.vue'
import PolicyCom from '@/views/Admin/SenceComponents/PolicyCom.vue'
import TunnelCtrViewVue from '@/views/Admin/TunnelCtrView.vue'
import KPIListViewVue from '@/views/Admin/Home/KPIListView.vue'
import KPIViewVue from '@/views/Admin/Home/KPIView.vue'
import KpiApproveVue from '@/views/Admin/Home/KpiApprove.vue'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'login',
    component: LoginView
  }, 
  {
    path: '/Home',
    name: 'Home',
    redirect:"/Home/Main",
    component: HomeView,
    meta: {
      isLogin: true,
      project: true
    },
    children:[
      {
        path:"/Home/Main",
        name:"home/main",
        component:HomeMain,
        meta: {
          isLogin: true,
          project: true
        },
      }, {
        path:"/Home/Oview",
        name:"home.Oview",
        component:OView,
        meta: {
          isLogin: true,
          project: true
        },
      }, {
        path:"/Home/Dust",
        name:"home.Dust",
        redirect:"/Home/Dust/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Dust/OView",
            name:"home.Dust.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Dust/Alarm",
            name:"home.Dust.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Dust/Link",
              name:"home.Dust.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Dust/Device",
              name:"home.Dust.Device",
              component:NormalDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },
      {
        path:"/Home/KPI",
        name:"home.KPI",
        redirect:"/Home/KPI/Method",
        component:CamaraVue,
        children:[
          {
            path:"/Home/KPI/Method",
            name:"home.KPI.Method",
            component:KPIViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/KPI/Data",
            name:"home.KPI.Data",
            component:KPIListViewVue,
            meta: {
              isLogin: true,
              project: true,
            }},{
              path:"/Home/KPI/App",
              name:"home.KPI.App",
              component:KpiApproveVue,
              meta: {
                isLogin: true,
                project: true,
              }}
        ]
      },
      {
        path:"/Home/Tunnel",
        name:"home.Tunnel",
        redirect:"/Home/Tunnel/Device",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Tunnel/OView",
            name:"home.Tunnel.OView",
            component:TunnelOViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Tunnel/Policy",
            name:"home.Tunnel.Policy",
            component:tunnelPolicyComVue,
            meta: {   isLogin: true,
              project: true,
              type:true
            }},  {
              path:"/Home/Tunnel/Ctrl",
              name:"home.Tunnel.Ctrl",
              component:TunnelCtrViewVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Tunnel/Device",
              name:"home.Tunnel.Device",
              component:ClightDevice,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Tunnel/Task",
              name:"home.Tunnel.Task",
              component:TaskCom,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },
      {
        path:"/Home/Voice",
        name:"home.Voice",
        redirect:"/Home/Voice/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Voice/OView",
            name:"home.Voice.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Voice/Alarm",
            name:"home.Voice.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Voice/Link",
              name:"home.Voice.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Voice/Device",
              name:"home.Voice.Device",
              component:NormalDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },
      {
        path:"/Home/Bridge",
        name:"home.Bridge",
        redirect:"/Home/Bridge/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Bridge/OView",
            name:"home.Bridge.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Bridge/Alarm",
            name:"home.Bridge.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Bridge/Link",
              name:"home.Bridge.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Bridge/Device",
              name:"home.Bridge.Device",
              component:NormalDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },{
        path:"/Home/EnvCar",
        name:"home.EnvCar",
        redirect:"/Home/EnvCar/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/EnvCar/OView",
            name:"home.EnvCar.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/EnvCar/Pointer",
            name:"home.EnvCar.Pointer",
            component:EnvCarPotinerVue,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/EnvCar/Log",
              name:"home.EnvCar.Log",
              component:EnvCarLogVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/EnvCar/Device",
              name:"home.EnvCar.Device",
              component:EnvCarDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/EnvCar/Detail",
              name:"home.EnvCar.Detail",
              component:EnvCarDeviceDetailVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },{
        path:"/Home/Fume",
        name:"home.Fume",
        redirect:"/Home/Fume/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Fume/OView",
            name:"home.Fume.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Fume/Alarm",
            name:"home.Fume.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Fume/Link",
              name:"home.Fume.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Fume/Device",
              name:"home.Fume.Device",
              component:NormalDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },{
        path:"/Home/Cover",
        name:"home.Cover",
        redirect:"/Home/Cover/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Cover/OView",
            name:"home.Cover.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Cover/Alarm",
            name:"home.Cover.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Cover/Link",
              name:"home.Cover.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Cover/Device",
              name:"home.Cover.Device",
              component:NormalDeviceCoverVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },
      {
        path:"/Home/Clight",
        name:"home.Clight",
        redirect:"/Home/Clight/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Clight/OView",
            name:"home.Clight.OView",
            component:DataCnViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },
          {
            path:"/Home/Clight/Admin",
            name:"home.Clight.Admin",
            component:ClightDevice,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          }, {
            path:"/Home/Clight/Ctrl",
            name:"home.Clight.Ctrl",
            component:CnComVue,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          }, {
            path:"/Home/Clight/Policy",
            name:"home.Clight.Policy",
            component:cnPolicyComVue,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          }, {
            path:"/Home/Clight/Task",
            name:"home.Clight.Task",
            component:TaskCom,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          }
        ]},
      {
        path:"/Home/DustCar",
        name:"home.DustCar",
        redirect:"/Home/DustCar/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/DustCar/OView",
            name:"home.DustCar.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/DustCar/Alarm",
            name:"home.DustCar.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/DustCar/Link",
              name:"home.DustCar.Link",
              component:AlarmLinkVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/DustCar/Device",
              name:"home.DustCar.Device",
              component:DustCarDeviceVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },{
        path:"/Home/LSensor",
        name:"home.LSensor",
        redirect:"/Home/LSensor/Device",
        component:CamaraVue,
        children:[
          {
            path:"/Home/LSensor/Device",
            name:"home.LSensor.Device",
            component:SensorDeviceCompoentVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/LSensor/Alarm",
            name:"home.LSensor.Alarm",
            component:SenceCompoentVue,
            meta: {
              isLogin: true,
              project: true
            }
          }
        ]
      },{
        path:"/Home/Project",
        name:"home.Project",
        redirect:"/Home/Project/Info",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Project/User",
            name:"home.Project.User",
            component:ProjectUserComVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Info",
            name:"home.Project.Info",
            component:ProjectInfoComVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Sub",
            name:"home.Project.Sub",
            component:ProjectAdminComVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Log",
            name:"home.Project.Log",
            component:ProjectLogVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Role",
            name:"home.Project.Role",
            component:ProjectRoleComVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Alarm",
            name:"home.Project.Alarm",
            component:PhoneAlarmVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Project/Power",
            name:"home.Project.Power",
            component:ProjectPowerComVue,
            meta: {
              isLogin: true,
              project: true
            }
          }
        
        ]},{
        path:"/Home/WOrder",
        name:"home.WOrder",
        redirect:"/Home/WOrder/Oview",
        component:CamaraVue,
        children:[
          {
            path:"/Home/WOrder/Oview",
            name:"home.WOrder.Oview",
            component:OrderOViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/WOrder/Asset",
            name:"home.WOrder.Asset",
            component:WorkOrderViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/WOrder/Type",
            name:"home.WOrder.Type",
            component:OrderTypeVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/WOrder/Admin",
            name:"home.WOrder.Admin",
            component:OrderAminViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/WOrder/Check",
            name:"home.WOrder.Check",
            component:CheckViewVue,
            meta: {
              isLogin: true,
              project: true
            }
          }
        ]
      },
      {
        path:"/Home/NDetail",
        name:"home.NDetail",
        component:NormalDeviceDetailVue,
        meta: {
          isLogin: true,
          project: true,
        }
    },
      
      {
        path:"/Home/Broad",
        name:"home.Broad",
        redirect:"/Home/Broad/OView",
        component:CamaraVue,
        children:[
          {
            path:"/Home/Broad/OView",
            name:"home.Broad.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },{
            path:"/Home/Broad/Alarm",
            name:"home.Broad.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},  {
              path:"/Home/Broad/Link",
              name:"home.Broad.Link",
              component:LinkTextVue,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            },  {
              path:"/Home/Broad/Device",
              name:"home.Broad.Device",
              component:BroadDevice,
              meta: {
                isLogin: true,
                project: true,
                type:true
              }
            }
        ]
      },
      {
        path:"/Home/Camra",
        name:"home.Camra",
        redirect:"/Home/Camra/OView",
        component:CamaraVue,
        meta: {
          isLogin: true,
          project: true
        },
        children:[
          {
            path:"/Home/Camra/OView",
            name:"home.Camra.OView",
            component:CaraOview,
            meta: {
              isLogin: true,
              project: true
            }
          },  {
            path:"/Home/Camra/Device",
            name:"home.Camra.Device",
            component:CamaraCeviceVue,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          },  {
            path:"/Home/Camra/Link",
            name:"home.Camra.Link",
            component:AlarmLinkVue,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          },  {
            path:"/Home/Camra/AI",
            name:"home.Camra.AI",
            component:AISubVue,
            meta: {
              isLogin: true,
              project: true,
              type:true
            }
          }, {
            path:"/Home/Camra/Alarm",
            name:"home.Camra.Alarm",
            component:HomeAlarm,
            meta: {
              isLogin: true,
              project: true,
            }},
            {
              path:"/Home/Camra/Detail",
              name:"home.Camra.Detail",
              component:VideoDetailVue,
              meta: {
                isLogin: true,
                project: true,
              }
          }
        ]
      }
    ]

  }, 
   {
    path: '/Check',
    name: 'Check',
    component: InspectionVue
  },
  {
   path: '/KPI',
   name: 'KPI',
   component: KPIDetailVue
 },
  {
    path: '/Main',
    name: 'amin',
    component: MainView,
    meta: {
      isLogin: true,
      project: true
    }
  },
  {
    path: '/Admin',
    name: 'Admin',
    component: AdminView,
    redirect:"/Admin/OView",
    meta: {
      isLogin: true,
      project: true,
      
    },
    children:[
      {
        path:"/Admin/Map",
        name:"admin.map",
        component:MapView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/OView",
        name:"admin.OView",
        component:DataView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/cnview",
        name:"admin.DataCnViewVue",
        component:DataCnViewVue,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/Order",
        name:"admin.Order",
        component:OrderViewVue,
        meta: {
          isLogin: true,
          project: true
        }
      },{
        path:"/Admin/OrderDetail",
        name:"admin.OrderDetail",
        component:OrderDetail,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/lightDetail",
        name:"admin.lightDetail",
        component:LightDetail,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/gg",
        name:"admin.LightSenceView",
        component:LightSenceView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/Map/Gateway",
        name:"admin.Map.Gateway",
        component:GatewayMapView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/PlatPolicy",
        name:"admin.PlatPolicy",
        component:PlatPolicyView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/jg",
        name:"admin.jg",
        component:JingGView,
        meta: {
          isLogin: true,
          project: true,
          box:true,
          gateway:true,
          router:true,
          type:true
        }
      },
      {
        path:"/Admin/Device",
        name:"admin.Device",
        component:DeviceView,
        meta: {
          isLogin: true,
          project: true,
          box:true,
          gateway:true,
          router:true,
          type:true
        }
      },
      {
        path:"/Admin/Setting",
        name:"admin.Setting",
        component:SetView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/Router",
        name:"admin.Router",
        component:RouterView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/Alarms",
        name:"admin.Alarms",
        component:AlarmView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/History",
        name:"admin.History",
        component:HistoryView,
        meta: {
          isLogin: true,
          project: true
        }
      },
      {
        path:"/Admin/Ctr",
        name:"admin.Ctr",
        component:CtrView,
        meta: {
          isLogin: true,
          project: true
        }},
        {
          path:"/Admin/Loop",
          name:"admin.Loop",
          component:LoopView,
          meta: {
            isLogin: true,
            project: true
          }
        },
        {
          path:"/Admin/Sence",
          name:"admin.Sence",
          component:SenceView,
          meta: {
            isLogin: true,
            project: true,
            type:true
          }
        },
        {
          path:"/Admin/GatewayDetail",
          name:"admin.GatewayDetail",
          component:GatewayDetail,
          meta: {
            isLogin: true,
            project: true,
            router:true,
            type:true
          }
        },
        {
          path:"/Admin/JG/JGDetail",
          name:"admin.jg.jgdetail",
          component:JGDetail,
          meta: {
            isLogin: true,
            project: true,
            router:true,
            type:true
          }
        }
    ]
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const array: string[] = [];
  if (to.meta?.isLogin) {
    const token = CookieUtil.getCookie(cookieTypes.XC_COOKIES_ACCESSTOKEN);
    if (!token || token === 'null') {
      router.push("/");
    }
  }
  if (to.meta?.project) {
    array.push(StoreTypes.XC_PROJECT_INFO);
  }
  if(to.meta?.box){
    array.push(StoreTypes.XC_DEVICE_BOX);
  }
  if(to.meta?.gateway){
    array.push(StoreTypes.XC_DEVICE_GATEWAY);
  }
  if(to.meta?.type){
    array.push(StoreTypes.XC_DEVICE_TYPE);
  }
  if(to.meta?.router){
    array.push(StoreTypes.XC_DEVICE_ROUTER);
  }
  const rhk: RouteHook = new RouteHook(array);
  rhk.action(store, false).then(() => { next() }).catch((err) => {
    throw err;
  })
})
export default router
